<template>
  <Cards>
    <TopSearch :adminShow="true" :searchShow="true" @searchKey="getSearchKey" ref="searchArea"
               @changeDra="changeDrafun"/>
  </Cards>
  <Cards>
    <div>
      <div style="position: relative">
        <div class="top_tips">
          <div>
            <h2 class="h2_titles">{{ $t("common.customer.list") }}</h2>
          </div>
          <div>
            <!--            <el-button-->
            <!--                :disabled="totals===0"-->
            <!--                type="danger"-->
            <!--                :icon="Delete"-->
            <!--                @click="handleClickDelete"-->
            <!--                v-if="isSuperAdmin"-->
            <!--                size="small"-->
            <!--            >-->
            <!--            </el-button-->
            <!--            >-->
            <el-button type="primary" :icon="Plus" @click="toDetails('Create')" size="small">{{
                $t("common.create")
              }}
            </el-button>
            <!--          批量导入-->
            <el-button type="primary" :icon="DocumentAdd" @click="fileImport" size="small">
              {{ $t('list.customer.location.import') }}
            </el-button>
            <el-button type="primary" :icon="Refresh" @click="handleRefresh" size="small" :loading="isLoadingRefresh">
              {{ $t('common.refresh') }}
            </el-button>
            <!--            &lt;!&ndash;          批量导出&ndash;&gt;-->
            <!--            <el-button size="small" :disabled="totals===0" type="primary" :icon="Upload" @click="fileExport"-->
            <!--                       v-if="isSuperAdmin"-->
            <!--                       :loading="isExportLoading">-->
            <!--              -->
            <!--            </el-button>-->
            <!--            more-->
            <el-dropdown trigger="click" style="margin-left: 12px" @command="handleCommand">
              <el-button size="small">
                <el-icon>
                  <MoreFilled/>
                </el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="editLevel">
                    <el-button link size="small" :icon="Edit">{{ i18n.global.t('customer.list.setting1') }}</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item command="editOrigin">
                    <el-button link size="small" :icon="Edit">{{ i18n.global.t('customer.list.setting2') }}</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item command="editProduct">
                    <el-button link size="small" :icon="Edit">{{ i18n.global.t('customer.list.setting3') }}</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item command="export" @click="fileExport" v-if="isSuperAdmin">
                    <el-button link size="small" type="primary" :icon="Upload" :disabled="totals===0"
                               :loading="isExportLoading">
                      {{ $t('list.customer.export.user') }}
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item command="delete" @click="handleClickDelete" v-if="isSuperAdmin">
                    <el-button link size="small" type="danger" :icon="Delete" :disabled="totals===0"
                    >
                      {{ $t('common.delete.customer') }}
                    </el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
        <Tables
            :totals="totals"
            ref="targetTable"
            :table-data="customerList"
            :table-colum-titles="table_columns_list"
            :is-show-pages="false"
            :isShowDrawer="true"
            :isShowEdit="true"
            :isLoading="isLoading"
            @selections="handleSelectionChange"
            @selectionChange="getSelectChange"
            @select-all="handleClickSelectAll"
            :searchArea="searchArea"
            :isSelectAllTarget="isSelectAll"
        >
          <template #linkUserHistory>
            <!--            <div class="settings">-->
            <el-button type="primary" style="font-size: 13px" link>{{ $t("common.contact.record") }}</el-button>
            <!--            </div>-->
          </template>
          <template v-if="isSuperAdmin" #deleteCustomer="{ row }">
            <ConfirmDeletePopover
                :visible="row.popoverVisibleReject"
                :width="164"
                :message="$t('list.customer.row.delete')"
                :ref="`popover-${$index}`"
                @update:visible="
                    (value) => (row.popoverVisibleReject = value)
                  "
                @confirm:delete="handleClickDeleteRow(row)"
            >
              <template #settings>
                <el-button
                    link
                    type="danger"
                    @click.native.stop="row.popoverVisibleReject = true"
                >{{ $t('common.delete') }}
                </el-button>
              </template>
            </ConfirmDeletePopover>
          </template>
        </Tables>
      </div>
    </div>
    <div class="pages">
      <!--      <el-pagination-->
      <!--          popper-class="page"-->
      <!--          v-model:current-page="current"-->
      <!--          v-model:page-size="size"-->
      <!--          :page-sizes="[10,30,50]"-->
      <!--          background-->
      <!--          :pager-count="4"-->
      <!--          layout="sizes, total, prev, pager, next ,jumper"-->
      <!--          v-if="totals"-->
      <!--          :total="totals"-->
      <!--          @size-change="handleSizeChange"-->
      <!--          @current-change="handleCurrentChange"-->
      <!--      />-->
      <Pagination v-model:modelValue="current"
                  v-model:pageSizeValue="size"
                  :total="totals"
                  v-if="totals"
                  ref="PageZQ"
                  :selected="selectedCount"
                  @change="handleCurrentChange"
                  @checkAllItemPage="checkAllItemPage"
                  @unCheckAllItemPage="unCheckAllItemPage"
                  @getSelect="getSelectValue"
                  :multipleSelection="multipleSelection"
                  :is-show-select="true"
      ></Pagination>
    </div>
  </Cards>
  <CustomerExcelImport v-if="visitable" v-model="visitable" @close="close"
                       @getCustomerList="refreshTable"></CustomerExcelImport>

  <DeleteCustomer v-if="dialogVisiblePopover" v-model="dialogVisiblePopover" @close="closeDialog"
                  :multipleSelection="multipleSelection" :getCustomerList="refreshTable"
                  :isSelectAll="isSelectAll" :searchValue="searchValue" :type="1"
  ></DeleteCustomer>

  <CustomerMoreSetting v-if="dialogVisible" v-model="dialogVisible" @close="closeMore"
                       :settingType="settingType" :multipleSelection="multipleSelection"
                       @getInit="resetInit" :isSelectAll="isSelectAll"
                       :searchValue="searchValue" @getList="getListCustomer"></CustomerMoreSetting>

</template>
<script setup>
import {ref, computed, watch, nextTick, onMounted, onBeforeUnmount} from "vue";
import {useRouter} from "vue-router";
import {Delete, DocumentAdd, Edit, Plus, Upload, Refresh} from "@element-plus/icons-vue";
import Cards from "./Cards.vue";
import TopSearch from "./TopComponents/TopSearch.vue";
import Tables from "./Tables/Tables.vue";
import {
  batchDeleteCustomerById,
  exportCustomerData,
  getMailCustomerList,
} from "@/api/customer";
import {useStore} from "vuex";
import {table_columns_list} from './map'
import {ElMessage} from "element-plus";
import CustomerExcelImport from "@/components/DiaPops/CustomerExcelImport.vue";
import {debouncePlus, throttle} from "@/utils/mylodash"
import {i18n} from "@/lang";
import DeleteCustomer from "@/components/DiaPops/DeleteCustomer.vue";
import {flattenChildren, replaceMailMassEmailVOListWithChildren} from "@/utils/filters";
import {emailReg, TIME_OUT} from "@/utils/statusParams";
import Pagination from "@/components/Pagination/index.vue";
import CustomerMoreSetting from "@/components/DiaPops/CustomerMoreSetting.vue";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";


const store = useStore()
// 权限控制
const isSuperAdmin = computed(() => store.getters["user/isSuperAdmin"])
const searchArea = ref(null)

const dialogVisible = ref(false)
const closeMore = () => {
  dialogVisible.value = false
}

const settingType = ref(0)
const handleCommand = (command) => {
  // dialogVisible.value = true
  switch (command) {
    case 'editLevel':
      if (multipleSelection.value.length <= 0) {
        ElMessage.warning(i18n.global.t('sys.tip.select.customer'))
        return
      }
      settingType.value = 1
      dialogVisible.value = true
      break;
    case 'editOrigin':
      if (multipleSelection.value.length <= 0) {
        ElMessage.warning(i18n.global.t('sys.tip.select.customer'))
        return
      }
      settingType.value = 2
      dialogVisible.value = true
      break;
    case 'editProduct':
      if (multipleSelection.value.length <= 0) {
        ElMessage.warning(i18n.global.t('sys.tip.select.customer'))
        return
      }
      settingType.value = 3
      dialogVisible.value = true
      break;
    case 'export':
      console.log('客户导出');
      break;
    case 'delete':
      console.log('删除');
      break;
    default:
      break;
  }
}


// 分页
const current = ref(1);
const size = ref(10);
const totals = ref(0);
const targetTable = ref(null)
// 选中的条数
const selectedCount = ref(10)

const teamId = computed(() => store.state.email.teamID);
const selectedRows = computed(() => store.state.customer.selectedRows)
const globalSelectedRows = computed(() => store.state.customer.globalSelectedRows)
const isCounterElection = computed(() => store.state.customer.isCounterElection);

const isEnterpriseMainUser = computed(() => store.getters['user/isEnterpriseMainUser']);
const isNormalUser = computed(() => store.getters['user/isNormalUser']);
// 刷新table
const refreshTable = async () => {
  await resetInit()
  await getCustomerList()
}

// 搜索
const searchValue = ref({});
const empty = ref(i18n.global.t('select.empty'))

const getSearchKey = async (value) => {
  // 重置选择
  nextTick(() => {
    isSelectAll.value = false
    targetTable.value.unCheckAllItem()
    targetTable.value.setIsSelectAll(false)
  })
  const newObj = JSON.parse(JSON.stringify(value));
  if (newObj.customerOrigin === empty.value) {
    newObj.customerOrigin = ''
  }
  if (newObj.product === empty.value) {
    newObj.product = ''
  }
  if (newObj.customerTypeId === empty.value) {
    newObj.customerTypeId = ''
  }
  // if (newObj.search) {
  //   newObj.search = ''
  // }
  searchValue.value = newObj;
  console.log(searchValue.value, 'searchValue.value')
  // 列表数据
  await getCustomerList();
  nextTick(() => {
    isSelectAll.value ? targetTable.value?.checkAllItem() : targetTable.value?.unCheckAllItem()
  })
};

const router = useRouter();
const multipleSelection = computed(() => store.state.customer.multipleSelection)
const isLoading = ref(false);

// table 选中的数组
const handleSelectionChange = async (val) => {
  console.log(val, 'val')
  endIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
  const startIndex = val.length > 1 ? customerList.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
  console.log(endIndex, startIndex);
  if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
    const start = startIndex < endIndex ? startIndex : endIndex;
    const end = endIndex < startIndex ? startIndex : endIndex;
    for (let i = start; i <= end; i++) {
      const row = customerList.value[i];
      if (start === i || i === end) {
        continue;
      }
      console.log(row, '更新');
      if (row) {
        targetTable.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
      }
    }
    nextTick(async () => {
      await store.commit("customer/setMultipleSelection", targetTable.value.getSelectionRows())
      console.log(targetTable.value.getSelectionRows(), '当前选中行');
    });
  } else {
    // multipleSelection.value = val;
    await store.commit("customer/setMultipleSelection", val)
  }
};


const isSelectAll = ref(false)
const getSelectValue = async (val) => {
  if (val !== undefined) {
    isSelectAll.value = val
  }
  await nextTick()
  customerList.value.forEach((item) => {
    targetTable?.value.toggleRowSelection(item, isSelectAll.value)
  })
}

const getSelectChange = async (val) => {
  console.log(val, '当前页勾选的值');
  // 选择 底部选择 取消 全部勾选
  await nextTick(async () => {
    // 获取当前页的页码，假设分页数据存储在 store 中
    const currentPage = current.value;

    // 获取全局勾选记录
    const globalSelectedRows = store.state.customer.globalSelectedRows || {};

    // 更新当前页的勾选数据到全局记录
    globalSelectedRows[currentPage] = val;

    // 提交更新全局勾选记录到 store
    await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

    // 合并所有页的勾选数据
    const allSelectedRows = Object.values(globalSelectedRows).flat();

    // 更新 `selectedRows` 和 `targetEmailList`
    await store.commit("customer/setSelectedRows", allSelectedRows);
  })
}

const handleClickSelectAll = async (val) => {
  console.log(val, '当前页勾选的值');
  // 获取当前页的页码，假设分页数据存储在 store 中
  const currentPage = current.value;

  // 获取全局勾选记录
  const globalSelectedRows = store.state.customer.globalSelectedRows || {};

  // 更新当前页的勾选数据到全局记录
  globalSelectedRows[currentPage] = val;

  // 提交更新全局勾选记录到 store
  await store.commit("customer/setGlobalSelectedRows", globalSelectedRows);

  // 合并所有页的勾选数据
  const allSelectedRows = Object.values(globalSelectedRows).flat();

  // 更新 `selectedRows` 和 `targetEmailList`
  await store.commit("customer/setSelectedRows", allSelectedRows);
}


// 删除按钮
const dialogVisiblePopover = ref(false)
const handleClickDelete = throttle(async (row) => {
  console.log(row, 'rowrowrow')
  if (multipleSelection.value && multipleSelection.value.length === 0 && !isSelectAll.value) {
    ElMessage.warning(i18n.global.t('common.email.chooseCustomer'));
    return;
  }
  dialogVisiblePopover.value = true;
}, 2000)

const handleClickDeleteRow = async (row) => {
  if (row) {
    await store.commit("customer/setMultipleSelection", [row])
  }
  const params = {
    customerIdList: [],
    teamId: teamId.value,
    customerOrigin: searchValue.value.customerOrigin,
    customerTypeId: searchValue.value.customerTypeId,
    customerName: searchValue.value.customerName,
    customerCode: searchValue.value.customerCode,
    email: searchValue.value.email,
    zoneAddress: searchValue.value.zoneAddress,
    type: 1,
    managerId: searchValue.value.managerId,
  }
  console.log(searchValue.value, 'searchValue.value')
  params.customerIdList = multipleSelection.value?.map(_ => _.id)
  await batchDeleteCustomerById(params).then(res => {
    ElMessage.success(i18n.global.t('delete.all.batch.success'))
    getCustomerList()
  }).catch(e => {
  })
}

const closeDialog = () => {
  targetTable.value.setIsSelectAll(false)
  targetTable.value.unCheckAllItem()
  dialogVisiblePopover.value = false;
}
/**
 * 新建客户
 * @param name
 * @param id
 * @returns {Promise<void>}
 */
const toDetails = async (name, id) => {
  let newUrl = router.resolve({
    name,
    params: {id},
    query: {contact: 1}
  });
  await store.commit('customer/setRuleForm', {
    zoneCode: "",
    customerCode: "",
    zoneAddress: "",
    customerName: "",
    setUpTime: "",
    economicNature: "",
    companyWebsite: "",
    companyAddress: "",
    phoneWayList: [],
    emailWayList: [],
    companyFax: "",
    companyRemark: "",
    customerLevel: "",
    customerType: "",
    customerTypeId: "",
    product: "",
    marketingRemark: " ",
    createBy: "",
    branchAdmin: "",
    mangerVOList: [{managerName: ''}]
  })
  await store.commit('customer/setForm', {
    phones: [{phoneNumber: "", isDefault: true}],
    emails: [{email: "", isDefault: true}],
  })
  openNewWindowTarget(newUrl.href);
};

const openNewWindow = (url) => {
  window.open(url, "_self");
};

const openNewWindowTarget = (url) => {
  window.open(url, "_blank");
};

async function handleCurrentChange(page) {
  const {pageNo, pageSize} = page
  current.value = pageNo
  size.value = pageSize
  //  重新获取数据
  await getCustomerList()
  // 全选
  if (isSelectAll.value) {
    await getSelectValue()
  }
}

async function handleSizeChange(pageSize) {
  size.value = pageSize;
  await getCustomerList();
  isSelectAll.value ? targetTable.value.checkAllItem() : targetTable.value.unCheckAllItem()
}

const checkAllItemPage = () => {
  console.log('checkAllItemPage', targetTable.value)
  targetTable.value.setIsSelectAll(true)
}

const unCheckAllItemPage = () => {
  console.log('unCheckAllItemPage', targetTable.value)
  targetTable.value.setIsSelectAll(false)
}

// 全部分管客户列表数据
const customerList = ref([]);
const userInfo = computed(() => store.state.user.userInfo)
/**
 * 获取客户列表
 * @returns {Promise<void>}
 */
const getCustomerList = async () => {
  if (searchValue.value.managerId === "all") {
    searchValue.value.managerId = "";
  }
  isLoading.value = true;

  try {
    const res = await getMailCustomerList({
      ...searchValue.value,
      pageSize: size.value,
      pageNo: current.value,
      teamId: teamId.value,
      type: 1,
    });

    const {records, total} = res.result;

    customerList.value = records;
    totals.value = total;
  } catch (error) {
    console.error(error);
  } finally {
    // 无论成功失败都会关闭 loading
    isLoading.value = false;
  }
};

const PageZQ = ref()
const resetInit = async () => {
  // parent
  isSelectAll.value = false
  // child
  try {
    await PageZQ.value.setIsSelectAll(isSelectAll.value)
    // 清空选项
    await store.commit("customer/setGlobalSelectedRows", []);
    await store.commit("customer/setSelectedRows", []);
    await store.commit("customer/setMultipleSelection", [])
    await targetTable?.value.unCheckAllItem()
  } catch (e) {

  }
}

watch(() => teamId.value, async () => {
  await getCustomerList();
  await store.dispatch("groups/getUserList", {teamId: teamId.value});
})

/**
 * 客户的批量导入
 */
const visitable = ref(false);
const fileImport = async (event) => {
  visitable.value = true;
}
const close = () => {
  visitable.value = false;
}

/**
 * 页面刷新
 */
const isLoadingRefresh = ref(false)
const handleRefresh = throttle(() => {
  isLoadingRefresh.value = true
  window.location.reload()
  isLoadingRefresh.value = false
}, TIME_OUT)


/**
 * 客户的批量导出
 */
const isExportLoading = ref(false)
const fileExport = throttle(async () => {
//   是否有选中的项？
  const params = {
    customerIdList: [],
    teamId: teamId.value,
    customerOrigin: searchValue.value.customerOrigin,
    customerTypeId: searchValue.value.customerTypeId,
    customerName: searchValue.value.customerName,
    customerCode: searchValue.value.customerCode,
    email: searchValue.value.email,
    zoneAddress: searchValue.value.zoneAddress,
    ...searchValue.value,
  }
  console.log(multipleSelection.value.length === 0, isSelectAll.value, 'show')

  if (multipleSelection.value.length === 0) {
    ElMessage.warning(i18n.global.t('common.email.chooseCustomer'))
    return
  } else if (isSelectAll.value) {
    //   否则全部导出
    delete params.customerIdList
    params.managerId = searchValue.value.managerId
  } else {
    //   有选中的项 就只导出选中的项
    params.customerIdList = multipleSelection.value.map(_ => _.id)
  }
  isExportLoading.value = true
  await exportCustomerData(params, {
    responseType: "blob",
  }).then(res => {
    console.log(res, 'res')
    isExportLoading.value = false
    const link = document.createElement('a');
    const blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'}); // 设置正确的字符编码
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', i18n.global.t('common.customer.info'));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}, 1000);


// 记录历史记录
const resetSelection = async () => {
  await nextTick(() => {
    console.log(targetTable?.value, customerList.value, selectedRows.value, 'treeTable?.value')
    if (targetTable?.value && selectedRows?.value.count > 0) {
      customerList.value.forEach((item) => {
        const isSelected = selectedRows.value?.some((selected) => selected.id === item.id);
        console.log(item, isSelected, selectedRows.value.map(item => item.id), 'isSelected')
        targetTable?.value.toggleRowSelection(item, isSelected);
      })
    }
  })
}

// 当前页数据发生变化
watch(() => customerList.value, (newValue) => {
  if (newValue) {
    console.log('newValue')
    resetSelection()
  }
}, {immediate: true})


onMounted(() => {
  // Shift监听/取消监听
  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
  document.removeEventListener('keyup', handleKeyUp);
});

let endIndex = -1;
// table 选择增加 shift
const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
const handleKeyDown = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    // console.log("进来了-----------------", event.key, event.keyCode);
    isShiftPressed.value = true;
  }
};

const handleKeyUp = (event) => {
  if (event.key === 'Shift' && event.keyCode === 16) {
    isShiftPressed.value = false;
  }
};
const drawer = ref(false)
const changeDrafun = async (val) => {
  // await nextTick()
  // targetTable.value.calcTableHeight()
}

const getListCustomer = async () => {
  await resetInit()
  await getCustomerList()
}
</script>

<style lang="less" scoped>
@import "../../less/page.less";
@import "../../less/resetFul.less";

.table_name {
  font-size: 20px;
}

.top_tips {
  display: flex;
  justify-content: space-between;
}

.settings {
  //display: flex;
  //justify-content: center;
}

:deep(.el-table__cell) {
  text-align: center;
}

:deep(.el-checkbox__inner::after) {
  top: 1px !important;
  left: 4px !important;
}

.affix-container {
  text-align: center;
  height: 400px;
  border-radius: 4px;
  background: var(--el-color-primary-light-9);
}

.pages :deep(.el-pagination .el-select) {
  width: 100px !important;
}

:deep(.el-pagination) {
  position: relative !important;
  background: white !important;
  z-index: 9;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}
</style>
